// Configuration de l'API selon l'environnement
const getApiBaseUrl = (): string => {
  const hostname = window.location.hostname;

  // Détecter l'environnement de production par le hostname
  if (hostname === 'nudge.todoweb.fr' || hostname.includes('todoweb.fr')) {
    return 'https://nudge.todoweb.fr';
  }

  // En développement local
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:3001';
  }

  // Par défaut, utiliser l'hostname actuel avec le port backend
  return `http://${hostname}:3001`;
};

export const API_BASE_URL = getApiBaseUrl();

// Debug: afficher l'URL de l'API en développement uniquement
if (process.env.NODE_ENV === 'development') {
  console.log('🔗 API_BASE_URL:', API_BASE_URL);
}

const apiConfig = {
  BASE_URL: API_BASE_URL
};

export default apiConfig;